import { useState } from "react";
import { FicheAgentItemProps } from "./SelectionFicheAgent.types";
import dayjs from 'dayjs'
import { Pressable, Text, View } from "react-native";
import styles from "./SelectionFicheAgent.styles";
import { useSessionStore } from "../../lib/Store/sessionStore.component";

export default function FicheAgentItem({ index, ficheAgent, navigation }: FicheAgentItemProps) {
  const { selectFicheAgent } = useSessionStore();
  const [isPressed, setIsPressed] = useState(false);
  const situationPrincipale = ficheAgent.loginInfo.situations.find((situation) => situation.principale);
  const entiteActuelle = ficheAgent.collectivites?.find((collectivite) => (
    collectivite.identifiantEntite === ficheAgent.loginInfo?.identifiantEntiteDefautEsag
  ));
  let textDate = "";
  if (situationPrincipale) {
    if (situationPrincipale.dateFin) {
      if (dayjs(situationPrincipale.dateFin).isSame(situationPrincipale.dateDebut, 'day')) {
        textDate = `Le ${dayjs(situationPrincipale.dateDebut).format('DD/MM/YYYY')}`;
      } else {
        textDate = `Du ${dayjs(situationPrincipale.dateDebut).format('DD/MM/YYYY')} au ${dayjs(situationPrincipale.dateFin).format('DD/MM/YYYY')}`;
      }
    } else {
      textDate = `Depuis le ${dayjs(situationPrincipale.dateDebut).format('DD/MM/YYYY')}`;
    }
  }

  return (
    <View style={styles.listContent}>
      <Pressable
        onPress={() => selectFicheAgent(ficheAgent.loginInfo.identifiant, navigation)}
        onPressIn={() => setIsPressed(true)}
        onPressOut={() => setIsPressed(false)}
        style={[
          styles.pressableItem,
          isPressed && styles.pressableItemActive
        ]}
        testID={`BT_FICHE_${index + 1}`}
      >
        <Text style={styles.tenantName}>
          {entiteActuelle?.libelle || 'N/A'}
        </Text>
        {situationPrincipale && (
          <>
            <Text style={styles.agentService}>
                {situationPrincipale.serviceSituations[0].service.libelle}
            </Text>
            {textDate &&(
              <Text style={styles.agentDate}>
                {textDate}
              </Text>
            )}
          </>
        )}
      </Pressable>
    </View>
  );
}